<template>
  <vx-card title="Leave Type">
    <div id="user-edit-tab-info">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-col w-full mb-base">
            <template>
              <vs-table
                stripe
                max-items="8"
                pagination
                search
                :data="getLeaveTypes"
              >
                <template slot="thead">
                  <vs-th>Id</vs-th>
                  <vs-th>Code</vs-th>
                  <vs-th>Description</vs-th>
                  <vs-th>Minimum Days</vs-th>
                  <vs-th>Maximum Days</vs-th>
                  <vs-th>Backdated</vs-th>
                  <vs-th>Attachment</vs-th>
                  <vs-th>Requires Reason</vs-th>
                  <vs-th>Accrued</vs-th>
                  <vs-th>Accrual Day</vs-th>
                  <vs-th>Forfeited</vs-th>
                  <vs-th>Forfeited Days</vs-th>
                  <vs-th>Carry Over</vs-th>
                  <vs-th>Carry Over Days</vs-th>
                  <vs-th>"Reservation Status"</vs-th>
                  <vs-th>Reserved Days</vs-th>
                  <vs-th>Convertible to Cash</vs-th>
                  <vs-th>Convertible Days</vs-th>
                  <vs-th>Expired Forfeited Month</vs-th>
                  <vs-th>Expired Forfeited Day</vs-th>
                  <vs-th>Expired Reserved Month</vs-th>
                  <vs-th>Expired Reserved Day</vs-th>
                  <vs-th>Expired Leave Month</vs-th>
                  <vs-th>Expired Leave Day</vs-th>
                  <vs-th>Consecutive Days</vs-th>
                  <vs-th>Max Attachment Count</vs-th>
                  <vs-th>Max Backdate Days</vs-th>
                  <vs-th>Taxable Excess Of</vs-th>
                  <vs-th>Available After (In Months)</vs-th>

                  <vs-th>Included in 13th Month</vs-th>
                  <vs-th>Included in Final Pay</vs-th>
                  <vs-th>Actions</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].leaveTypeId">
                      {{ data[indextr].leaveTypeId }}
                    </vs-td>
                    <vs-td :data="data[indextr].leaveTypeCode">
                      {{ data[indextr].leaveTypeCode }}
                    </vs-td>
                    <vs-td :data="data[indextr].leaveTypeName">
                      {{ data[indextr].leaveTypeName }}
                    </vs-td>
                    <vs-td :data="data[indextr].minDays">
                      {{ data[indextr].minDays }}
                    </vs-td>
                    <vs-td :data="data[indextr].maxDays">
                      {{ data[indextr].maxDays }}
                    </vs-td>
                    <vs-td :data="data[indextr].isBackDate">
                      <vs-checkbox
                        v-model="data[indextr].isBackDate"
                        class="pointer-events-none"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].isAttachment">
                      <vs-checkbox
                        v-model="data[indextr].isAttachment"
                        class="pointer-events-none"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].isRequiredReason">
                      <vs-checkbox
                        v-model="data[indextr].isRequiredReason"
                        class="pointer-events-none"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].isAccrued">
                      <vs-checkbox
                        v-model="data[indextr].isAccrued"
                        class="pointer-events-none"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].dayOfMonthAccrued">
                      {{ data[indextr].dayOfMonthAccrued }}
                    </vs-td>
                    <vs-td :data="data[indextr].isForfeited">
                      <vs-checkbox
                        v-model="data[indextr].isForfeited"
                        class="pointer-events-none"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].daysForForfeited">
                      {{ data[indextr].daysForForfeited }}
                    </vs-td>
                    <vs-td :data="data[indextr].isCarryOver">
                      <vs-checkbox
                        v-model="data[indextr].isCarryOver"
                        class="pointer-events-none"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].daysForCarryOver">
                      {{ data[indextr].daysForCarryOver }}
                    </vs-td>
                    <vs-td :data="data[indextr].isReserved">
                      <vs-checkbox
                        v-model="data[indextr].isReserved"
                        class="pointer-events-none"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].daysForReserved">
                      {{ data[indextr].daysForReserved }}
                    </vs-td>
                    <vs-td :data="data[indextr].isConvertibleToCash">
                      <vs-checkbox
                        v-model="data[indextr].isConvertibleToCash"
                        class="pointer-events-none"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].daysConvertibleToCash">
                      {{ data[indextr].daysConvertibleToCash }}
                    </vs-td>
                    <vs-td :data="data[indextr].monthExpiredForfeited">
                      {{ data[indextr].monthExpiredForfeited }}
                    </vs-td>
                    <vs-td :data="data[indextr].dayExpiredForfeited">
                      {{ data[indextr].dayExpiredForfeited }}
                    </vs-td>
                    <vs-td :data="data[indextr].monthExpiredReserved">
                      {{ data[indextr].monthExpiredReserved }}
                    </vs-td>
                    <vs-td :data="data[indextr].dayExpiredReserved">
                      {{ data[indextr].dayExpiredReserved }}
                    </vs-td>
                    <vs-td :data="data[indextr].monthExpiredLeave">
                      {{ data[indextr].monthExpiredLeave }}
                    </vs-td>
                    <vs-td :data="data[indextr].dayExpiredLeave">
                      {{ data[indextr].dayExpiredLeave }}
                    </vs-td>
                    <vs-td :data="data[indextr].consecutiveDays">
                      {{ data[indextr].consecutiveDays }}
                    </vs-td>
                    <vs-td :data="data[indextr].maxCountForAttachment">
                      {{ data[indextr].maxCountForAttachment }}
                    </vs-td>
                    <vs-td :data="data[indextr].maxDaysforBackDate">
                      {{ data[indextr].maxDaysforBackDate }}
                    </vs-td>
                    <vs-td :data="data[indextr].taxableInExcessOf">
                      {{ data[indextr].taxableInExcessOf }}
                    </vs-td>
                    <vs-td :data="data[indextr].leaveAvailAfterHowManyMonths">
                      {{ data[indextr].leaveAvailAfterHowManyMonths }}
                    </vs-td>
                    <vs-td :data="data[indextr].isIncludedIn13thMonth">
                      <vs-checkbox
                        v-model="data[indextr].isIncludedIn13thMonth"
                        class="pointer-events-none"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].isIncludedInFinalPay">
                      <vs-checkbox
                        v-model="data[indextr].isIncludedInFinalPay"
                        class="pointer-events-none"
                      />
                    </vs-td>

                    <vs-td>
                      <feather-icon
                        icon="Edit3Icon"
                        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                        @click="editRecord(data[indextr].leaveTypeId)"
                      />
                      <feather-icon
                        icon="Trash2Icon"
                        svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                        @click="confirmDeleteRecord(data[indextr].leaveTypeId)"
                      />
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </template>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            type="gradient"
            color="primary"
            @click="promptAddNewRecord()"
            icon-pack="feather"
            icon="icon-plus"
            >Add</vs-button
          >
        </div>
      </div>

      <!-- ADD LEAVE TYPE -->
      <vs-prompt
        class="email-compose"
        title="Add Type of Leave"
        accept-text="Submit"
        @accept="onAddNewRecord"
        :is-valid="validForm"
        :active.sync="activePromptAddRecord"
      >
        <vx-card title="Please fill-out the following information">
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Code</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.leaveTypeCode"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Description</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.leaveTypeName"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Minimum Days</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.minDays"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Maximum Days</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.maxDays"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <div class="flex">
                <vs-checkbox v-model="leaveType.isBackDate"
                  >Backdated</vs-checkbox
                >
              </div>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <div class="flex">
                <vs-checkbox v-model="leaveType.isAttachment"
                  >Attachment</vs-checkbox
                >
              </div>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <div class="flex">
                <vs-checkbox v-model="leaveType.isRequiredReason"
                  >Requires Reason</vs-checkbox
                >
              </div>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <div class="flex">
                <vs-checkbox v-model="leaveType.isAccrued">Accrued</vs-checkbox>
              </div>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Accrual Day</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.dayOfMonthAccrued"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <div class="flex">
                <vs-checkbox v-model="leaveType.isForfeited"
                  >Forfeited</vs-checkbox
                >
              </div>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Forfeited Days</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.daysForForfeited"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <div class="flex">
                <vs-checkbox v-model="leaveType.isCarryOver"
                  >Carry Over</vs-checkbox
                >
              </div>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Carry Over Days</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.daysForCarryOver"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <div class="flex">
                <vs-checkbox v-model="leaveType.isReserved"
                  >Reservation Status</vs-checkbox
                >
              </div>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Reserved Days</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.daysForReserved"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <div class="flex">
                <vs-checkbox v-model="leaveType.isConvertibleToCash"
                  >Convertible to Cash</vs-checkbox
                >
              </div>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Convertible Days</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.daysConvertibleToCash"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Expired Forfeited Month</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.monthExpiredForfeited"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Expired Forfeited Days</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.dayExpiredForfeited"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Expired Reserved Month</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.dayExpiredReserved"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Expired Reserved Day</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.monthExpiredLeave"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Expired Leave Month</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.monthExpiredLeave"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Expired Leave Day</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.dayExpiredLeave"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Consecutive Days</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.consecutiveDays"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Max Attachment Count</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.maxCountForAttachment"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Max Backdate Days</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.maxDaysforBackDate"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Taxable Excess Of</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.taxableInExcessOf"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Available After (In Months)</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.leaveAvailAfterHowManyMonths"
              />
              <div class="vx-row mb-3">
                <div class="vx-col sm:w-1/2 w-full mb-4">
                  <div class="flex">
                    <vs-checkbox v-model="leaveType.isIncludedIn13thMonth"
                      >Included in 13th Month</vs-checkbox
                    >
                  </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-4">
                  <div class="flex">
                    <vs-checkbox v-model="leaveType.isIncludedInFinalPay"
                      >Included in Final Pay</vs-checkbox
                    >
                  </div>
                </div>
              </div>
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
        </vx-card>
      </vs-prompt>
      <!-- END ADD LEAVE TYPE -->
      <!-- EDIT LEAVE -->
      <vs-prompt
        class="email-compose"
        title="Edit Earnings"
        accept-text="Submit"
        @accept="onUpdateRecord"
        :is-valid="validForm"
        :active.sync="activePromptEditRecord"
      >
        <vx-card title="You may update the following information">
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Code</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.leaveTypeCode"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Description</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.leaveTypeName"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Minimum Days</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.minDays"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Maximum Days</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.maxDays"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <div class="flex">
                <vs-checkbox v-model="leaveType.isBackDate"
                  >Backdated</vs-checkbox
                >
              </div>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <div class="flex">
                <vs-checkbox v-model="leaveType.isAttachment"
                  >Attachment</vs-checkbox
                >
              </div>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <div class="flex">
                <vs-checkbox v-model="leaveType.isRequiredReason"
                  >Attachment</vs-checkbox
                >
              </div>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <div class="flex">
                <vs-checkbox v-model="leaveType.isAccrued"
                  >Requires Reason</vs-checkbox
                >
              </div>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Accrual Day</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.dayOfMonthAccrued"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>

          <div class="vx-col sm:w-1/2 w-full mb-4">
            <div class="flex">
              <vs-checkbox v-model="leaveType.isAccrued">Accrued</vs-checkbox>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Forfeited Days</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.daysForForfeited"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>

          <div class="vx-col sm:w-1/2 w-full mb-4">
            <div class="flex">
              <vs-checkbox v-model="leaveType.isForfeited"
                >Forfeited</vs-checkbox
              >
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Carry Over Days</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.daysForCarryOver"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>

          <div class="vx-col sm:w-1/2 w-full mb-4">
            <div class="flex">
              <vs-checkbox v-model="leaveType.isCarryOver"
                >Carry Over</vs-checkbox
              >
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Reserved Days</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.daysForReserved"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>

          <div class="vx-col sm:w-1/2 w-full mb-4">
            <div class="flex">
              <vs-checkbox v-model="leaveType.isReserved"
                >Reservation Status</vs-checkbox
              >
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Convertible Days</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.daysConvertibleToCash"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>

          <div class="vx-col sm:w-1/2 w-full mb-4">
            <div class="flex">
              <vs-checkbox v-model="leaveType.isConvertibleToCash"
                >Convertible to Cash</vs-checkbox
              >
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Expired Forfeited Month</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.monthExpiredForfeited"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Expired Forfeited Day</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.dayExpiredForfeited"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Expired Reserved Month</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.monthExpiredReserved"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Expired Reserved Day</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.dayExpiredReserved"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Expired Leave Month</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.monthExpiredLeave"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Expired Leave Day</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.dayExpiredLeave"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Consecutive Days</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.consecutiveDays"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Max Attachment Count</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.maxCountForAttachment"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Max Backdate Days</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.maxDaysforBackDate"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Taxable Excess Of</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.taxableInExcessOf"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Available After (In Months)</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="leaveType.leaveAvailAfterHowManyMonths"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <div class="flex">
                <vs-checkbox v-model="leaveType.isIncludedIn13thMonth"
                  >Included in 13th Month</vs-checkbox
                >
              </div>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <div class="flex">
                <vs-checkbox v-model="leaveType.isIncludedInFinalPay"
                  >Included in Final Pay</vs-checkbox
                >
              </div>
            </div>
          </div>
        </vx-card>
      </vs-prompt>
      <!-- END EDIT LEAVE -->
    </div>
  </vx-card>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  data() {
    return {
      leaveType: {
        leaveTypeId: 0,
        leaveTypeCode: "",
        leaveTypeName: "",
        minDays: 0,
        maxDays: 0,
        isBackDate: true,
        isAttachment: false,
        isRequiredReason: false,
        isAccrued: false,
        dayOfMonthAccrued: 1,
        isForfeited: false,
        daysForForfeited: 1,
        isCarryOver: false,
        daysForCarryOver: 1,
        isReserved: false,
        daysForReserved: 0,
        isConvertibleToCash: false,
        daysConvertibleToCash: 1,
        monthExpiredForfeited: 0,
        dayExpiredForfeited: 1,
        monthExpiredReserved: 0,
        dayExpiredReserved: 1,
        monthExpiredLeave: 0,
        dayExpiredLeave: 1,
        consecutiveDays: 0,
        maxCountForAttachment: 0,
        maxDaysforBackDate: 0,
        taxableInExcessOf: 0,
        leaveAvailAfterHowManyMonths: 0,
        isIncludedIn13thMonth: false,
        isIncludedInFinalPay: false,
      },
      activePromptAddRecord: false,
      activePromptEditRecord: false,
    };
  },
  created() {
    this.$store.dispatch("lookup/getAllLeaveTypeLookup").catch((err) => {
      console.log(err);
    });
  },
  components: {
    "v-select": vSelect,
    Datepicker,
    flatPickr,
  },
  computed: {
    getLeaveTypes() {
      return this.$store.state.lookup.getAllLeaveTypes;
    },
    addLeaveTypeLookup() {
      return this.$store.state.lookup.addLeaveTypeLookup;
    },

    validForm() {},
  },
  methods: {
    // for editing, adding and deleting
    promptAddNewRecord() {
      this.activePromptAddRecord = true;
    },
    onAddNewRecord() {
      this.$vs.loading();
      this.$store
        .dispatch("lookup/addLeaveTypeLookup", this.leaveType) // For Ref, Line 130 modulelookupactions
        .then((response) => {
          this.$vs.loading.close();
          if (response.status == 200)
            this.$alert("", "Save Successfully", "success");
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$alert(error, "Error", "error");
        });
    },
    editRecord(id) {
      const e = this.$store.getters["lookup/leaveTypeLookup"](id);

      this.leaveType.leaveTypeId = id;
      this.leaveType.leaveTypeCode = e.leaveTypeCode;
      this.leaveType.leaveTypeName = e.leaveTypeName;
      this.leaveType.minDays = e.minDays;
      this.leaveType.maxDays = e.maxDays;
      this.leaveType.isBackDate = e.isBackDate;
      this.leaveType.isAttachment = e.isAttachment;
      this.leaveType.isRequiredReason = e.isRequiredReason;
      this.leaveType.isAccrued = e.isAccrued;
      this.leaveType.dayOfMonthAccrued = e.dayOfMonthAccrued;
      this.leaveType.isForfeited = e.isForfeited;
      this.leaveType.daysForForfeited = e.daysForForfeited;
      this.leaveType.isCarryOver = e.isCarryOver;
      this.leaveType.daysForCarryOver = e.daysForCarryOver;
      this.leaveType.isReserved = e.isReserved;
      this.leaveType.daysForReserved = e.daysForReserved;
      this.leaveType.isConvertibleToCash = e.isConvertibleToCash;
      this.leaveType.daysConvertibleToCash = e.daysConvertibleToCash;
      this.leaveType.monthExpiredForfeited = e.monthExpiredForfeited;
      this.leaveType.dayExpiredForfeited = e.dayExpiredForfeited;
      this.leaveType.monthExpiredReserved = e.monthExpiredReserved;
      this.leaveType.dayExpiredReserved = e.dayExpiredReserved;
      this.leaveType.monthExpiredLeave = e.monthExpiredLeave;
      this.leaveType.dayExpiredLeave = e.dayExpiredLeave;
      this.leaveType.consecutiveDays = e.consecutiveDays;
      this.leaveType.maxCountForAttachment = e.maxCountForAttachment;
      this.leaveType.maxDaysforBackDate = e.maxDaysforBackDate;
      this.leaveType.taxableInExcessOf = e.taxableInExcessOf;
      this.leaveType.leaveAvailAfterHowManyMonths =
        e.leaveAvailAfterHowManyMonths;
      this.leaveType.isIncludedIn13thMonth = e.isIncludedIn13thMonth;
      this.leaveType.isIncludedInFinalPay = e.isIncludedInFinalPay;

      this.activePromptEditRecord = true;
    },
    onUpdateRecord() {
      this.$vs.loading();
      this.$store
        .dispatch("lookup/updateLeaveTypeLookup", this.leaveType)
        .then((response) => {
          this.$vs.loading.close();
          if (response.status == 200)
            this.$alert("", "Updated Successfully", "success");
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$alert(error, "Error", "error");
        });
    },
    // confirmDeleteRecord(id) {
    //   Swal.fire({
    //     title: "Are you sure you want to <strong>continue</strong>?",
    //     text: "",
    //     icon: "warning",
    //     customClass: {
    //       icon: "no-before-icon",
    //     },
    //     showCancelButton: true,
    //     confirmButtonColor: "3085d6",
    //     cancelButtonColor: "#d33",
    //     confirmButtonText: "Confirm",
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       this.$vs.loading();
    //       this.$store
    //         .dispatch("lookup/deleteLoanSubCategory", id)
    //         .then((response) => {
    //           this.$vs.loading.close();
    //           if (response.status == 200) {
    //             this.$alert("", "Deleted Successfully", "success");
    //           }
    //         })
    //         .catch((error) => {
    //           this.$vs.loading.close();
    //           this.$alert(error, "Error", "error");
    //         });
    //     } else this.$alert("", "Cancelled Delete", "success");
    //   });
    // },
  },
};
</script>
